module.exports = __webpack_public_path__ + "img/chat-disable.bd82fa74.svg";